module.exports = "../../../../platform/assets/pageMainIcon/icon-renyuan-1-blue.svg";